import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { RouterLink } from 'vue-router';
import { LINK_INJECTION_KEY } from '@/ui';

import '@fontsource-variable/inter';
import '@fontsource-variable/dm-sans';
import '@fontsource/caveat/600.css';
import './assets/css/main.css';

import App from './App.vue';
import router from './router';

createApp(App)
  .use(createPinia())
  .use(router)
  .provide(LINK_INJECTION_KEY, RouterLink)
  .mount('#app');
